import { MdArrowForwardIos } from "react-icons/md";

import { InnerRow } from "pages/setting/components/Layout.styled";

export const MenuItem = ({ onClick, menuName, style }) => {
  return (
    <InnerRow style={{ cursor: "pointer", ...style }} onClick={onClick}>
      <span>{menuName}</span>
      <MdArrowForwardIos />
    </InnerRow>
  );
};
